// ViewTabs.js
import { Tabs, Tab, Box } from '@mui/material';
import { AppStyle } from '../value/AppConst';

export default function ViewTabs({
    selectedTabId,
    viewMetas, // {id, label}
    onChangeTab,
}) {
    return(
        <Box
            style={{
                width:'100%',
                marginBottom:10,
            }}
        >
            <Tabs value={selectedTabId} onChange={(e, v) => onChangeTab(v)}
                style={{
                    width:'100%',
                    borderBottom: AppStyle.BorderEEE,
                }}
            >
                {
                    viewMetas.map((meta) => {
                        return(
                            <Tab key={meta.id} label={meta.label} value={meta.id} />
                        )
                    })
                }
            </Tabs>
        </Box>
    );
}
